import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { motion } from "framer-motion";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Loader2, MailX, MailCheck, AlertTriangle } from "lucide-react";

export default function Unsubscribe() {
  const [params] = useSearchParams();
  const u = params.get("u") || "";
  const s = params.get("s") || "";
  const [state, setState] = useState({ status: "working" });

  const call = (resubscribe) =>
    api.post("/email/unsubscribe", { u, s, resubscribe })
      .then((r) => setState({ status: "done", ...r.data }))
      .catch((e) => setState({ status: "error", detail: e?.response?.data?.detail || "This link is not valid." }));

  useEffect(() => { if (u && s) call(false); else setState({ status: "error", detail: "This link is missing its code." }); }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className="flex min-h-screen items-center justify-center bg-background px-4 py-16">
      <motion.div initial={{ opacity: 0, y: 12 }} animate={{ opacity: 1, y: 0 }} className="w-full max-w-md rounded-2xl border border-border bg-card p-8 text-center shadow-sm" data-testid="unsubscribe-card">
        {state.status === "working" && <Loader2 className="mx-auto h-6 w-6 animate-spin text-muted-foreground" />}
        {state.status === "error" && (
          <>
            <AlertTriangle className="mx-auto h-8 w-8 text-amber-600" />
            <h1 className="mt-4 font-serif text-2xl font-semibold text-foreground">Hmm, that didn’t work</h1>
            <p className="mt-2 text-sm text-muted-foreground" data-testid="unsubscribe-error">{state.detail} You can always change email preferences from your profile after signing in.</p>
          </>
        )}
        {state.status === "done" && state.email_opt_out && (
          <>
            <MailX className="mx-auto h-8 w-8 text-primary" />
            <h1 className="mt-4 font-serif text-2xl font-semibold text-foreground" data-testid="unsubscribe-done">You’re unsubscribed</h1>
            <p className="mt-2 text-sm text-muted-foreground">{state.email} won’t get announcements, Friday reminders or replay notices anymore. Account emails like password resets still come through.</p>
            <Button variant="outline" className="mt-6" onClick={() => call(true)} data-testid="unsubscribe-undo">Oops — keep me on the list</Button>
          </>
        )}
        {state.status === "done" && !state.email_opt_out && (
          <>
            <MailCheck className="mx-auto h-8 w-8 text-emerald-600" />
            <h1 className="mt-4 font-serif text-2xl font-semibold text-foreground" data-testid="resubscribe-done">You’re back on the list</h1>
            <p className="mt-2 text-sm text-muted-foreground">{state.email} will keep getting Friday Conversations updates.</p>
          </>
        )}
        <p className="mt-6 text-xs text-muted-foreground"><Link to="/" className="text-primary hover:underline">Back to Friday Conversations</Link></p>
      </motion.div>
    </div>
  );
}
